import { AuthService } from '@shared/services/guards/auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { environment } from '@environments/environment';
import { RouteService } from './route.service';
import { ServiceRequestService } from '../service-request.service';
import { fetchAuthSession, signInWithRedirect } from 'aws-amplify/auth';

@Injectable()
export class AuthGuard implements CanActivate {

    route: any;
    constructor(
        public _requestService: ServiceRequestService,
        private _authService: AuthService) {}

     /*canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
          return this._authService.isAuthenticated()
             .then(result => {
                 if (result) {
                     return true;
                 } else {
                     localStorage.setItem('prev_url', state.url)
                     window.location.replace(environment.signIn);
                     return false;
                 }
             });
     }*/

     canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return Promise
            .all([this._authService.isAuthenticated(), this. isTokenStillValid()])
            .then( async (values) => {
                if (values[0] && values[1]) {
                    return true;
                } else {
                    console.log("FAILED 2 CONDITIONS AUTH TOKEN")
                    localStorage.clear();
                    localStorage.setItem('prev_url', state.url)
                    // window.location.replace(environment.signIn);
                    await signInWithRedirect()
                    return false;
                }

            })
            .catch(() => false )
    }

    async isTokenStillValid() {
        const email = localStorage.getItem('userEmail');
        const token = (await fetchAuthSession()).tokens.idToken.toString();

        console.log('tokenn', token, email);
        console.log("IS TOKEN STILL VALID = "), localStorage.getItem('isLoggedIn')

        if (localStorage.getItem('isLoggedIn') !== 'true') {
            localStorage.clear();
            // window.location.replace(environment.signIn);
            await signInWithRedirect()
            return false;
        }

        return new Promise((resolve , reject) => {
            this._requestService
                .getLoginToken(token, email)
                .subscribe(
                    data => {
                        const res = data['body'];
                        resolve(res.token === 'true');
                    },
                    error => {reject(error)})
        });

    }

}
